import { render, staticRenderFns } from "./QuizBoard.vue?vue&type=template&id=5a03fc39&scoped=true"
import script from "./QuizBoard.vue?vue&type=script&lang=js"
export * from "./QuizBoard.vue?vue&type=script&lang=js"
import style0 from "./QuizBoard.vue?vue&type=style&index=0&id=5a03fc39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03fc39",
  null
  
)

export default component.exports